import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'wo-consent-approval-text',
  templateUrl: './consent-text.component.html',
  styleUrls: [ './consent-text.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DatePipe,
  ],
})
export class ConsentTextComponent {
  public readonly dateOfPublication = new Date('2023-08-31');
}
